import React from 'react';
import '../../../../styles/Commons.css';
import {Card, Col, Row, Tag} from "antd";
import Contacte from "../../../../model/multilleure/gestioinscripcions/Contacte";
import { format } from 'date-fns';
interface element {
    element: Contacte
}

const PlantillaLista = (ele: element) => {


    return (
        <Card bordered={true}>
            <Row gutter={16}>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Email</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag color={"green"}>{ele.element.email}</Tag>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Direcció</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.direccio}</div>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>DNI</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag color={"green"}>{ele.element.dni}</Tag>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>IBAN</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag>{ele.element.IBAN} {ele.element.IBANentitat} {ele.element.IBANoficina} {ele.element.IBANdc} {ele.element.IBANnum}</Tag>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <br/>
            <Row gutter={16}>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Quota</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.quota}</div>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Creació</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag>{ele.element.creacio !== null ? format(new Date(ele.element.creacio), 'dd-MM-yyyy') : ""}</Tag>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Modificació</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag>{ele.element.modificacio !== null ? format(new Date(ele.element.modificacio), 'dd-MM-yyyy') : ""}</Tag>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Parentesc</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.parentesc}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    );
};
export default PlantillaLista;
